
import { defineComponent, PropType } from 'vue';
import { OioInput } from '@kunlun/vue-ui-antd';
import { CoefficientRow } from './services';

export default defineComponent({
  name: 'CoefficientConfigTable',
  components: {
    OioInput
  },
  props: {
    rows: {
      type: Array as PropType<CoefficientRow[]>,
      default: () => []
    }
  },
  setup() {
    /** D级去除超账龄次数/电商客户/线下客户三个空格，不允许编辑 */
    const isRatingD = (row: CoefficientRow) => row.creditRating === 'D';

    /** 超账龄次数默认0、1、2次以上，不允许编辑，仅展示 */
    const formatOverLimitTimes = (row: CoefficientRow) => {
      if (isRatingD(row) || row.overLimitTimes === null || row.overLimitTimes === undefined) {
        return '';
      }
      const times = Number(row.overLimitTimes);
      if (times >= 2) {
        return '2次以上';
      }
      return String(times);
    };

    return { isRatingD, formatOverLimitTimes };
  }
});
